<template>
  <v-card>
    <v-card-title class="headline"> {{room.roomName}} </v-card-title>

    <v-card-text>
      <v-container>
        <h3 class="h3Title">회원 검색</h3>
        <div class="fieldWrap">
          <ul class="fieldBx">
            <li class="formList">
              <dl>
                <dt class="formTit">회원 구분</dt>
                <dd class="d-flex align-center">
                  <v-col class="d-flex" sm="2">
                    <v-select v-model="param.searchState" :items="userStateItems" item-text="label"
                              item-value="value" label="상태"
                              dense solo flat outlined clearable/>
                  </v-col>
                  <v-col class="d-flex" sm="2">
                    <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"
                              item-value="roleId" label="역할"
                              dense solo flat outlined clearable/>
                  </v-col>
                  <v-col class="d-flex" sm="2">
                    <v-select v-model="param.searchGroup" :items="departmentItems" item-value="groupId" item-text="groupName"
                              dense
                              flat
                              solo
                              clearable
                              outlined
                              label="분과"
                              v-on:change="search"/>
                  </v-col>
                  <v-col class="d-flex" sm="2">
                    <v-select v-model="param.searchGroup" :items="clubItems" item-value="groupId" item-text="groupName"
                              dense
                              clearable
                              flat
                              solo
                              outlined
                              label="동호회"
                              v-on:change="search"/>
                  </v-col>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl>
                <dt class="formTit">포함할 회원</dt>
                <dd>
                  <v-col class="mgr" sm="6">
                    <user-search-component @callback-event="v => param.searchIncludeUsers = v" />
                  </v-col>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl>
                <dt class="formTit">제외할 회원</dt>
                <dd>
                  <v-col class="mgr" sm="6">
                    <user-search-component @callback-event="v => param.searchExcludeUsers = v"  />
                  </v-col>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl class="wh100">
                <dt class="formTit">검색 키워드</dt>
                <dd class="checkSt">
                  <v-col sm="6">
                    <v-text-field label="아이디/이름/이메일/휴대폰번호 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined
                    />
                  </v-col>
                                <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
        <h3 class="h3Title">회원 목록</h3>
        <div class="d-flex">
          <div class="tableBx">
            <div class="tableBtnBx">
              <p class="searchAll">
                <v-checkbox class="mgr" label="" v-model="allSelected"/>
                검색 된 총 <span class="txtPoint"> {{ totalItems }}명 </span> 선택
              </p>
              <div class="tableBtn">
                <ul>
                  <li class="tableBtnList"><span class="black-color">{{ selected != null ? selected.length : 0 }}</span> 건
                    선택됨
                  </li>
<!--                  <li class="tableBtnList" style="width: 400px">-->
<!--                    <vue-tags-input-->
<!--                        v-model="includeMobileNo"-->
<!--                        :tags="includeMobileNos"-->
<!--                        @tags-changed="addMobileNo"-->
<!--                        :validation="[{-->
<!--                          classes: 'no-numbers',-->
<!--                          rule: /^[0][1][0,1,6,7,8,9]\d{7,8}$/,-->
<!--                          disableAdd: true-->
<!--                        }]"-->
<!--                        placeholder="추가 초대 회원 핸드폰 번호만 입력 후 enter"-->
<!--                    />-->
<!--                  </li>-->
                </ul>
              </div>
            </div>
            <div class="">
              <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="userList"
                  :server-items-length="totalItems"
                  :options.sync="options"
                  :loading="listLoading"
                  item-key="userId"
                  show-select
                  class="elevation-1"
                  :footer-props="{showFirstLastPage: true}"
                  disable-sort
              >
                <template v-slot:item.state="{value}">
                  {{ userStateItems.filter(i => i.value === value)[0].text }}
                </template>
                <template v-slot:item.userHasRoles="{value}">
                  <!--            {{ $t(value) }}-->
                  <span
                      class="d-inline-block text-truncate"
                      style="max-width: 100px;"
                  >
                  {{ value.length > 0 ? value.length > 1 ? value[0].role.roleName + ' 외 ' + (value.length-1)  : value[0].role.roleName : '' }}
                    <!--              <template v-for="(role, index) in item.userHasRoles"><span v-if="index !== 0"  :key="index">, </span>{{role.role.roleName}}</template>-->
                </span>

                </template>
                <template v-slot:item.userId="{value}">
                    {{ value }}
                </template>
                <template v-slot:item.birthDate="{value, item}">
                  {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
                </template>

                <template v-slot:item.createdAt="{ value }">
                  {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
                </template>

                <template v-slot:item.departmentGroup="{value}">
                  {{  userGroupName(value) }}
                </template>
                <template v-slot:item.clubGroup="{value}">
                  {{  userGroupName(value) }}
                </template>

              </v-data-table>
            </div>
          </div>
        </div>
        <div class="d-flex">
    <!--      <v-btn color="grey" dark @click="userDialog = false">창닫기</v-btn>-->
          <v-spacer></v-spacer>
          <v-btn color="grey"  style="margin-right: 3px" dark @click="$emit('callback-close')">창닫기</v-btn>
          <v-btn color="primary" style="margin-right: 30px" dark @click="invite">초대하기</v-btn>
        </div>
      </v-container>
    </v-card-text>

    <!--        <v-card-actions>-->
    <!--          <v-spacer></v-spacer>-->
    <!--          <v-btn color="grey" dark @click="userDialog = false">창닫기</v-btn>-->
    <!--        </v-card-actions>-->
  </v-card>

</template>

<script>
import userApi from '@/api/UserApi'
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";
import hypermeetingApi from '@/api/HypermeetingApi'

import userSearchComponent from "@/views/component/UserSearchComponent";

// import _ from 'lodash';
// import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: "InviteUser",
  components: {
    // VueTagsInput,
    userSearchComponent
  },
  props: {
    roomId: String
  },
  data: () => ({
    user: {},
    room: {},
    userType: [{text: '전체', value: null}, {text: '1 회원', value: false}, {text: '2 회원', value: true}],
    userStateItems: [],
    userRoleItems: [],
    departmentItems:[],
    clubItems:[],

    includeMobileList: [],
    includeUser: '',
    includeMobileNo: '',
    exceptUser: '',
    includeMobileNos: [],
    listLoading: true,
    allSelected: false,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    totalItems: 0,
    singleSelect: false,
    param:{},
    selected: [],
    headers: [
      {text: '이름', value: 'name', align: 'left'},
      {text: '아이디', value: 'userId', align: 'left'},
      {text: '분과', value: 'departmentGroup', align: 'left'},
      {text: '동호회', value: 'clubGroup', align: 'left'},
      {text: '휴대폰번호', value: 'mobileNo'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
    ],
    userList: [],
    searchUserKeyword:null,
    waitingSearch: false
  }),
  computed: {},
  watch: {
    roomId: {
      handler(nv) {
        this.selected = []
        this.param = {}
        this.userList = []
        if(nv) {
          this.getHypermeeting(nv)
          this.search()
        }
      }
    },
    options: {
      handler() {
        this.search()
      },
      deep: true,
    }
  },
  methods: {
    userGroupName(value) {
      const approvalList = value?.filter(v => v.joinState === 'STATE_APPROVAL')??[];
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    getHypermeeting(roomId) {
      hypermeetingApi.get(roomId).then(data => {
        this.room = data;
        this.selected = this.room.hypermeetingUsers.map(u => {
          return {"userId":u.id.userId}
        });

        // console.log(this.selected)
      });
    },
    search() {
      this.listLoading = true;
      const params = {...this.param, ...this.options};
      if (this.activeItem > 0) {
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      params.searchIncludeUsers = this.param.searchIncludeUsers?.map(o => o.userId)??null;
      params.searchExcludeUsers = this.param.searchExcludeUsers?.map(o => o.userId)??null;

      userApi.list(params).then(data => {
        this.userList = data.content;
        this.totalItems = data.totalElements;
        this.listLoading = false;
        // this.selected = [];
      });

    },
    // addMobileNo(value) {
    //   this.includeMobileList = value.map(v => v.text);
    // },
    invite() {

      if (!this.allSelected && (this.selected??[]).length === 0 && (this.includeMobileList?? []).length === 0) {
        alert("회의에 초대하실 회원을 선택해주세요.");
        return;
      }

      let payload = {
        roomId : this.roomId
      }

      this.param.searchIncludeUsers = this.searchIncludeUsers?.map(o => o.userId)??null;
      this.param.searchExcludeUsers = this.searchExcludeUsers?.map(o => o.userId)??null;

      payload.searchRole = this.param.searchRole;
      payload.searchGroup = this.param.searchGroup;
      payload.searchState = this.param.searchState;
      payload.allSelected = this.allSelected;
      payload.sendUserList = this.selected.map(s => s.userId);
      // payload.includeMobileList = this.includeMobileList;

      if(this.roomId && this.selected) {
        hypermeetingApi.invite(this.roomId, payload).then(result => {
          console.log(result);
          this.$emit('callback-close')
        })
      }

    }
  },
  created: function () {
    this.userList = []
    this.selected = []
    this.param = {}

    userApi.stateList().then(data => {
      // console.log(data);
      this.userStateItems = data;
    });
    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });

    if(this.roomId) {
      this.getHypermeeting(this.roomId);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.h3Title {
  @include h3-title;
}

.col {
  padding: 0;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
          flex: 0 0 80px;
        }

        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.tableBtnBx {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .searchAll {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    /*font-size: 13px;*/
    .txtPoint {
      color: $point-color;
    }
  }
}

.tableBx {
  flex: 1 auto;
  margin-right: 30px;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }
}

.ti-new-tag-input {
  font-size: 12px;
}

.mobileBX {
  width: 300px;

  .bxLine {
    position: relative;
    padding: 34px 10px;
    border: 1px solid #dcdee3;
    border-radius: 30px;
    box-shadow: 0 3px 6px #eee;

    &::before {
      content: '';
      position: absolute;
      top: 15px;
      left: 120px;
      width: 135px;
      height: 15px;
      background: url('~@/assets/images/common/bg_sms_phone02.png') no-repeat;
    }

    .bxBg {
      padding: 20px 15px;
      background: #f8f8fa;
      font-size: 12px;
      font-family: 'dotum', sans-serif;

      .smsDetailInfo {
        padding: 14px 10px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.38);
        background: #fff;

        dl {
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }

          dt {
            flex: 0 0 62px;
            width: 62px;
          }
        }
      }

      .select {
        .mgr {
          margin-right: 4px !important;
        }
      }
    }
  }
}

.smsTemplateBx {
  width: 23%;
  margin-right: 2.6%;
  border: 1px solid #dcdee3;
  background: #f8f8f8;
  margin-bottom: 25px;

  &:nth-of-type(4n) {
    margin-right: 0;
  }

  ul {
    padding: 15px;
  }

  .templateTit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 5px;
    border-bottom: 1px solid #dcdee3;
  }

  .descTxt {
    font-size: 12px;
    color: #666;
  }

  .bestTxt {
    font-size: 12px;

    .best {
      color: #2196f3;
    }
  }

}

</style>
